
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/fire-risk-assessment",
      function () {
        return require("private-next-pages/services/fire-risk-assessment/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/fire-risk-assessment"])
      });
    }
  